module.exports = __webpack_public_path__ + "img/cnpc.72686fe9.png";